export default __webpack_public_path__ + "static/media/12.b9c9c4cd.svg";